import React, { memo } from 'react';

import { useMutateCreateSectorsSettings } from '@hooks/sectors/useMutateCreateSectorsSettings';

import SectorsSettingsForm, { ISectorsSettingsProps } from '../SectorsSettingsForm/SectorsSettingsForm';

function CreateSectorsSettingsForm(props: ISectorsSettingsProps) {
	const { createSectorsSettings, isCreatingSectorsSettings } = useMutateCreateSectorsSettings(props.closeModal);

	return (
		<SectorsSettingsForm
			{...props}
			isLoading={isCreatingSectorsSettings}
			submitHandler={createSectorsSettings}
		/>
	);
}

export default memo(CreateSectorsSettingsForm);
